import { render, staticRenderFns } from "./imgShow.vue?vue&type=template&id=1ec214c7&scoped=true&"
import script from "./imgShow.vue?vue&type=script&lang=js&"
export * from "./imgShow.vue?vue&type=script&lang=js&"
import style0 from "./imgShow.vue?vue&type=style&index=0&id=1ec214c7&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec214c7",
  null
  
)

export default component.exports